import React from 'react'

type StepSelectMessageType = {
  dispatch: React.Dispatch<any>
  selectedValue: string
  hasOffer: boolean
}

export function StepSelectMessageType({
  dispatch,
  selectedValue,
  hasOffer,
}: StepSelectMessageType) {
  const messageTypes = [
    {
      value: 'request-information',
      label: 'General Information',
    },
    {
      value: 'request-multi-document',
      label: 'Required Documents',
    },
    {
      value: 'request-esignature',
      label: 'eSign Documents',
      tooltip: !hasOffer
        ? 'This deal is not at a stage where documents can be sent for eSigning.'
        : null,
    },
  ]

  return (
    <>
      {messageTypes.map((option) => (
        <div
          key={option.value}
          className='form-control'
        >
          <div
            className='tooltip tooltip-bottom'
            data-tip={option?.tooltip}
          >
            <label className='label cursor-pointer hover:bg-gray-100 hover:rounded'>
              <span className='label-text'>{option.label}</span>
              <input
                type='radio'
                name='msgType'
                className='radio'
                value={option.value}
                checked={selectedValue === option.value}
                disabled={option.value === 'request-esignature' && !hasOffer}
                onChange={() => {
                  dispatch({ type: 'setMsgType', payload: option.value })
                }}
              />
            </label>
          </div>
        </div>
      ))}
    </>
  )
}
